import { render, staticRenderFns } from "./KimsaRadioGroup.vue?vue&type=template&id=31fb6d73&scoped=true"
import script from "./KimsaRadioGroup.vue?vue&type=script&lang=js"
export * from "./KimsaRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./KimsaRadioGroup.vue?vue&type=style&index=0&id=31fb6d73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fb6d73",
  null
  
)

export default component.exports